"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedInternalNotification =
/*#__PURE__*/
function (_pb_1$InternalNotific) {
  _inherits(ExtendedInternalNotification, _pb_1$InternalNotific);

  function ExtendedInternalNotification(properties) {
    var _this;

    _classCallCheck(this, ExtendedInternalNotification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedInternalNotification).call(this, properties));
    _this.type = ExtendedInternalNotification.type;
    return _this;
  }

  _createClass(ExtendedInternalNotification, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.property).concat(ExtendedInternalNotification.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.InternalNotification.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedInternalNotification(pb_1.InternalNotification.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedInternalNotification;
}(pb_1.InternalNotification);

ExtendedInternalNotification.type = "InternalNotification";
ExtendedInternalNotification.context = "/internal-notification";
exports.InternalNotification = ExtendedInternalNotification;